export class ApiConstants {
}
ApiConstants.BASE_URL = process.env.API_BASE_URL || '';
ApiConstants.REST_URL = ApiConstants.BASE_URL + '/rest/';
